import styles from '../../assets/css/accounts.module.css';
import Account from './Account';
import { Account as AccountType } from '../../types/account';

interface AccountsListProps {
	accounts: Array<AccountType>;
	selectedAccount: AccountType | null;
	onAccountSelect(account: AccountType): void;
}

const AccountsList = ({ accounts, selectedAccount, onAccountSelect }: AccountsListProps) => {
	return (
		<div className={styles['accounts-list-container']}>
			{accounts.map((account) => (
				<Account
					account={account}
					key={account.id || account.iban}
					isSelected={!!selectedAccount && account.id === selectedAccount.id}
					onSelect={onAccountSelect}
				/>
			))}
		</div>
	);
};

export default AccountsList;
